import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Steps } from "antd";
import { Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import "../Mcq/Mcq.css";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
const { Title } = Typography;

const McqFail = (props) => {
  useEffect(() => {
    localStorage.setItem("testPriority", 1);
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };

  return (
    <>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        <div className="row justify-content-center ">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={1}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <Title className="sub-title text-center  pt-5">MCQ Test</Title>
          <div className="col-xl-9 col-lg-9 col-md-12 p-0 m-0 mb-5 pb-5">
            <div className="card-body p-0 ">
              <>
                <div className="question-border text-center">
                  <svg
                    id="SvgjsSvg1001"
                    width="288"
                    height="288"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                  >
                    <defs id="SvgjsDefs1002"></defs>
                    <g id="SvgjsG1008" transform="matrix(1,0,0,1,0,0)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 307 211"
                        width="288"
                        height="288"
                      >
                        <path
                          fill="#ffd6d6"
                          d="M187.244 36.9457H119.311C117.965 36.9457 116.87 35.5561 116.87 33.853 116.87 32.1499 117.965 30.7603 119.311 30.7603H187.244C188.59 30.7603 189.685 32.1499 189.685 33.853 189.685 35.5561 188.59 36.9457 187.244 36.9457zM187.244 50.6513H119.311C117.965 50.6513 116.87 49.2617 116.87 47.5586 116.87 45.8554 117.965 44.4658 119.311 44.4658H187.244C188.59 44.4658 189.685 45.8554 189.685 47.5586 189.685 49.2617 188.59 50.6513 187.244 50.6513zM167.763 64.3566H119.311C117.965 64.3566 116.87 62.967 116.87 61.2639 116.87 59.5608 117.965 58.1711 119.311 58.1711H167.763C169.109 58.1711 170.204 59.5608 170.204 61.2639 170.204 62.967 169.109 64.3566 167.763 64.3566z"
                          class="colorDADBDC svgShape"
                        ></path>
                        <path
                          fill="#ff2626"
                          d="M151.942 147.354C167.957 147.354 180.94 134.397 180.94 118.414C180.94 102.431 167.957 89.4735 151.942 89.4735C135.927 89.4735 122.944 102.431 122.944 118.414C122.944 134.397 135.927 147.354 151.942 147.354Z"
                          class="color083DCC svgShape"
                        ></path>
                        <path
                          fill="#ffffff"
                          d="M165.241 107.575L162.532 104.868L151.791 115.599L141.05 104.868L138.341 107.575L149.082 118.306L138.341 129.037L141.05 131.744L151.791 121.013L162.532 131.744L165.241 129.037L154.5 118.306L165.241 107.575Z"
                          class="colorfff svgShape"
                        ></path>
                        <rect
                          width="296.144"
                          height="181.5"
                          x="5"
                          y="5"
                          stroke="#ffb7b7"
                          rx="15"
                          class="colorStrokeDADBDC svgStroke"
                        ></rect>
                        <path
                          fill="#950000"
                          d="M280.881 210.299C280.881 210.528 280.694 210.714 280.465 210.714H189.995C189.765 210.714 189.579 210.528 189.579 210.299C189.579 210.07 189.765 209.884 189.995 209.884H280.465C280.694 209.884 280.881 210.07 280.881 210.299Z"
                          class="color3F3D58 svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M246.157 81.4646L239.127 83.8583L239.017 73.7285L245.414 73.6565L246.157 81.4646Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M239.84 76.525C243.722 76.525 246.87 73.3839 246.87 69.5091C246.87 65.6344 243.722 62.4933 239.84 62.4933C235.957 62.4933 232.81 65.6344 232.81 69.5091C232.81 73.3839 235.957 76.525 239.84 76.525Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#560000"
                          d="M241.763 68.7929C240.587 68.7718 239.802 67.594 239.33 66.5136C238.859 65.4375 238.375 64.1962 237.284 63.7598C236.389 63.4039 234.843 65.8908 234.13 65.2426C233.387 64.5648 234.066 61.0314 234.839 60.3917C235.612 59.752 236.677 59.6164 237.679 59.5571C240.128 59.4173 242.591 59.5867 244.997 60.0612C246.483 60.3536 248.02 60.8027 249.102 61.8618C250.474 63.2048 250.843 65.2511 250.962 67.1661C251.085 69.1234 250.991 71.1782 250.058 72.9067C249.119 74.631 247.137 75.9189 245.214 75.5038C245.01 74.4658 245.193 73.3981 245.256 72.339C245.32 71.2841 245.227 70.1444 244.573 69.3098C243.919 68.4752 242.535 68.1574 241.792 68.9116"
                          class="color2F2E43 svgShape"
                        ></path>
                        <path
                          fill="#560000"
                          d="M250.436 71.1274C251.132 70.6063 251.969 70.1657 252.834 70.2631C253.773 70.3648 254.571 71.1274 254.821 72.034C255.072 72.9407 254.813 73.9447 254.244 74.6946C253.675 75.4445 252.822 75.9444 251.913 76.1986C251.387 76.3469 250.814 76.4105 250.309 76.1986C249.566 75.8894 249.158 74.9531 249.438 74.1989"
                          class="color2F2E43 svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M224.278 137.409C223.836 139.718 224.715 141.815 226.247 142.091C227.776 142.366 229.376 140.714 229.817 138.405C230.008 137.485 229.966 136.532 229.694 135.63L235.102 99.4447L227.818 98.161L225.42 134.863C224.834 135.613 224.439 136.486 224.278 137.413V137.409Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#ff2626"
                          d="M238.999 79.2107L234.037 79.2658C230.535 79.8335 229.601 81.7145 228.845 85.1716C227.686 90.4462 226.209 97.4748 226.519 97.5722C227.016 97.7332 235.506 101.606 239.802 100.648L238.999 79.2107Z"
                          class="color083DCC svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M245.094 194.214L238.489 194.288L238.593 203.638L245.198 203.564L245.094 194.214Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#560000"
                          d="M232.207 209.373C231.511 209.381 230.896 209.373 230.429 209.334C228.671 209.195 226.986 207.919 226.133 207.174C225.751 206.839 225.623 206.297 225.814 205.831C225.95 205.496 226.23 205.242 226.578 205.136L231.201 203.763L238.651 198.624L238.736 198.773C238.77 198.828 239.522 200.145 239.776 201.039C239.874 201.378 239.853 201.662 239.713 201.882C239.615 202.035 239.479 202.124 239.369 202.179C239.505 202.319 239.933 202.602 241.249 202.797C243.164 203.081 243.55 201.094 243.563 201.009L243.576 200.942L243.631 200.904C244.535 200.306 245.091 200.035 245.286 200.09C245.409 200.124 245.609 200.183 246.212 205.572C246.267 205.742 246.662 206.979 246.416 208.169C246.148 209.466 240.489 209.08 239.36 208.991C239.326 208.996 235.098 209.343 232.199 209.373H232.207Z"
                          class="color2F2E43 svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M263.814 186.646L258.249 190.197L263.295 198.075L268.861 194.524L263.814 186.646Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#560000"
                          d="M256.595 207.818C255.819 207.826 255.105 207.742 254.596 207.657 254.095 207.572 253.7 207.182 253.615 206.683 253.552 206.322 253.658 205.962 253.896 205.691L257.088 202.086 260.683 193.79 260.836 193.871C260.891 193.901 262.229 194.621 262.92 195.244 263.184 195.481 263.315 195.731 263.315 195.994 263.315 196.176 263.247 196.324 263.179 196.426 263.37 196.472 263.884 196.485 265.102 195.955 266.877 195.184 266.151 193.295 266.117 193.219L266.092 193.155 266.121 193.096C266.571 192.113 266.902 191.587 267.093 191.528 267.216 191.494 267.416 191.435 270.787 195.688 270.922 195.803 271.916 196.642 272.336 197.781 272.794 199.023 267.794 201.683 266.783 202.204 266.754 202.23 261.528 206.106 259.38 207.216 258.527 207.657 257.512 207.801 256.587 207.809L256.595 207.818zM249.073 115.951L230.581 116.154 229.096 133.338 237.144 196.693 246.585 196.587 242.404 159.991 258.085 192.901 266.41 186.944 254.108 156.195C254.108 156.195 258.081 129.246 254.651 122.581 251.221 115.917 249.077 115.943 249.077 115.943V115.951H249.073z"
                          class="color2F2E43 svgShape"
                        ></path>
                        <path
                          fill="#ff2626"
                          d="M258.281 116.896L228.914 117.222L237.302 79.2322L250.101 79.0881L258.281 116.896Z"
                          class="color083DCC svgShape"
                        ></path>
                        <path
                          fill="#ff8989"
                          d="M261.151 137.003C261.643 139.303 260.811 141.417 259.287 141.727C257.763 142.036 256.129 140.422 255.636 138.121C255.424 137.206 255.445 136.253 255.696 135.342L249.481 99.284L256.736 97.8394L259.949 134.482C260.552 135.219 260.964 136.083 261.151 137.007V137.003Z"
                          class="colorF3A3A6 svgShape"
                        ></path>
                        <path
                          fill="#ff2626"
                          d="M245.138 79.1432L250.101 79.0881C253.615 79.5796 254.588 81.4395 255.424 84.8796C256.697 90.1288 258.332 97.1192 258.026 97.2251C257.529 97.3946 249.133 101.453 244.815 100.593L245.142 79.1432H245.138Z"
                          class="color083DCC svgShape"
                        ></path>
                      </svg>
                    </g>
                  </svg>

                  <p className="text-danger">Please try again later</p>
                  <Link to={"/"}>
                    <Button
                      type="primary"
                      className="btn btn-primary result-btn"
                    >
                      Login
                    </Button>
                  </Link>
                </div>
              </>
            </div>
          </div>
        </div>
        <FooterRegistraion />
      </div>
    </>
  );
};

export default McqFail;
